module.exports = __webpack_public_path__ + "vu.svg?5bc20756ed74f649e3ce3722b2a9c5a1";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/vu.svg
// module id = 1692
// module chunks = 0